'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_AuditView$AuditName(name, deleted) {
  this.Ct = null;
  this.Cs = false;
  this.Ct = name;
  this.Cs = deleted;
}
export { $c_Lpresto_AuditView$AuditName as $c_Lpresto_AuditView$AuditName };
$p = $c_Lpresto_AuditView$AuditName.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_AuditView$AuditName;
/** @constructor */
function $h_Lpresto_AuditView$AuditName() {
}
export { $h_Lpresto_AuditView$AuditName as $h_Lpresto_AuditView$AuditName };
$h_Lpresto_AuditView$AuditName.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  var acc = (-889275714);
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_T__hashCode__I("AuditName"));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().A(this.Ct));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, (this.Cs ? 1231 : 1237));
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().ai(acc, 2);
});
$p.i = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lpresto_AuditView$AuditName) && ((this.Cs === x$0.Cs) && (this.Ct === x$0.Ct))));
});
$p.l = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().H(this);
});
$p.r = (function() {
  return 2;
});
$p.s = (function() {
  return "AuditName";
});
$p.j = (function(n) {
  if ((n === 0)) {
    return this.Ct;
  }
  if ((n === 1)) {
    return this.Cs;
  }
  throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lpresto_AuditView$AuditName(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.hP)));
}
export { $isArrayOf_Lpresto_AuditView$AuditName as $isArrayOf_Lpresto_AuditView$AuditName };
var $d_Lpresto_AuditView$AuditName = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_AuditView$AuditName, "presto.AuditView$AuditName", ({
  hP: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lpresto_AuditView$AuditName as $d_Lpresto_AuditView$AuditName };
//# sourceMappingURL=presto.-Audit-View$-Audit-Name.js.map
